// This is a streamline version of js-base64 to avoid inject entire dependency.
// If you need full function, please replace below code with js-base64.
// https://github.com/dankogai/js-base64
const _fromCC = String.fromCharCode.bind(String);
export const encodeBase64 = (str: string) => {
    if (str.length === 0) {
        return str;
    }
    // cf. https://stackoverflow.com/questions/12710001/how-to-convert-uint8-array-to-base64-encoded-string/12713326#12713326
    const maxargs = 0x1000;
    const utf8Array: Uint8Array = (new TextEncoder()).encode(str);
    const strs = [];
    for (var i = 0, l = str.length; i < l; i += maxargs) {
        // @ts-ignore
        strs.push(_fromCC.apply(null, utf8Array.subarray(i, i + maxargs)));
    }
    return btoa(strs.join(''));
}

export const encodeBase64URI = (str: string) => {
    return encodeBase64(str)
        .replace(/=/g, '')
        .replace(/[+\/]/g, function (m0) { return m0 == '+' ? '-' : '_'; });
}